import { UseQueryOptions, useQuery } from 'react-query';
import { DefaultGetResponse } from '~/App/Api/rest';
import axios, { AxiosError } from 'axios';
import { AddOnPrice } from '~/types/models/addon';

export const queryKeys = {
  detail: ['add-on-price', 'detail'] as const,
};

export interface GetAddOnsPricesResponse {
  data: AddOnPrice[];
}

export async function getAddOnsPrices() {
  const res = await axios.get<GetAddOnsPricesResponse>('/api/v3/addons/prices');
  return res.data.data;
}

export interface UseAddOnsPricesParams {
  options?: UseQueryOptions<DefaultGetResponse<AddOnPrice[]>, AxiosError>;
}

export const useAddOnsPrices = ({ options }: UseAddOnsPricesParams) =>
  useQuery<DefaultGetResponse<AddOnPrice[]>, AxiosError>(
    queryKeys.detail,
    getAddOnsPrices,
    options
  );
